import React from 'react';
import Loader from '../../ui/Loader/index';

class Welcome extends React.Component {
  render() {
    return (
      <div className="App">
        <Loader show={true}/>
        <header className="App-header">
          <h1 className="App-title">Welcome to React</h1>
        </header>
        <p className="App-intro">
          To get started, edit <code>src/App.js</code> and save to reload.
        </p>
      </div>
    );
  }
}

export default Welcome;



// WEBPACK FOOTER //
// ./src/views/Welcome/index.js